// extracted by mini-css-extract-plugin
export default {"title":"_6469b8c27f","inner_title":"edc433b209","charge_btn":"_7a5ff2fbb2"};